import { Request } from '../request';
import { ProviderInsuranceSurveyReq } from 'types/verify';

export const saveProviderInsuranceSurvey = (data: ProviderInsuranceSurveyReq) =>
    Request.post({ url: '/schedule-server/provider/insurance/survey', params: data });

export const getProviderUniprofileInsurances = () =>
    Request.get({ url: '/schedule-server/provider/uniprofile/insurances' });
